import axios from 'axios';
import {getSettings} from './SettingsRepository';
import {getUrl} from '../../util/URLS';

export const getData = async (queryParams) => {
    const response = await axios.get(
        getUrl() + '/BenefitDesignToolApi?id=' + queryParams.id
        + '&employeeRange=' + queryParams.employeeRange
        + '&industry=' + queryParams.industry
        + '&region=' + queryParams.region
        + '&role=' + queryParams.role
    );
    return response.data;
};

export const postData = async (data) => {
    const settings = await getSettings();
    const response = await axios.post(
        `${settings.url}/BenefitDesignToolApi/save`,
        data
    );
    return response.status;
};